// Logging condicional para no contaminar la consola en producción.
// Para activar: en devtools → Application → Local Storage →
//   `localStorage.setItem('vp_debug', '1')` y recarga.
// Para apagar: `localStorage.removeItem('vp_debug')`.
//
// `console.warn` y `console.error` SIEMPRE se mantienen (señalan problemas reales).
export const debug = (...args) => {
  if (typeof window !== "undefined" && window.localStorage?.getItem("vp_debug") === "1") {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};
